export function saveProfileToIndexedDB(profile) {

    if (!profile) {

    return; // não tenta salvar null
  }
  const request = indexedDB.open("MyAppDB", 5);

  request.onupgradeneeded = function (event) {
    const db = event.target.result;
    if (!db.objectStoreNames.contains("profiles")) {
      db.createObjectStore("profiles");
    }
  };

  request.onsuccess = function (event) {
    const db = event.target.result;
    const tx = db.transaction("profiles", "readwrite");
    const store = tx.objectStore("profiles");

    store.put(profile, "entityProfile");

    tx.oncomplete = function () {
      db.close();
    //   console.log("Perfil salvo com sucesso no IndexedDB");
    };
  };

  request.onerror = function () {
    console.error("Erro ao abrir IndexedDB");
  };
}

export function saveUserToIndexedDB(user) {

    if (!user) {

    return; 
  }
  const request = indexedDB.open("MyAppDB", 5);

  request.onupgradeneeded = function (event) {
    const db = event.target.result;
    if (!db.objectStoreNames.contains("userData")) {
      db.createObjectStore("userData");
    }
  };

  request.onsuccess = function (event) {
    const db = event.target.result;
    const tx = db.transaction("userData", "readwrite");
    const store = tx.objectStore("userData");

    store.put(user, "userData");

    tx.oncomplete = function () {
      db.close();
    //   console.log("User salvo com sucesso no IndexedDB");
    };
  };

  request.onerror = function () {
    // console.error("Erro ao abrir IndexedDB");
  };
}

export function saveEntityProfileSelectedToIndexedDB(entityProfile2) {

    if (!entityProfile2) {

    return; 
  }
  const request = indexedDB.open("MyAppDB", 5);

  request.onupgradeneeded = function (event) {
    const db = event.target.result;
    if (!db.objectStoreNames.contains("entityProfileSelect")) {
      db.createObjectStore("entityProfileSelect");
    }
  };

  request.onsuccess = function (event) {
    const db = event.target.result;
    const tx = db.transaction("entityProfileSelect", "readwrite");
    const store = tx.objectStore("entityProfileSelect");

    store.put(entityProfile2, "entityProfileSelect");

    tx.oncomplete = function () {
      db.close();
    //   console.log("EntityProfileSelected salvo com sucesso no IndexedDB");
    };
  };

  request.onerror = function () {
    console.error("Erro ao abrir IndexedDB");
  };
}


export function loadProfileFromIndexedDB(callback) {
  const request = indexedDB.open("MyAppDB", 5);

  request.onupgradeneeded = function (event) {
    const db = event.target.result;

    if (!db.objectStoreNames.contains("profiles")) {
      db.createObjectStore("profiles");
    }

    if (!db.objectStoreNames.contains("userData")) {
      db.createObjectStore("userData");
    }

    if (!db.objectStoreNames.contains("entityProfileSelect")) {
      db.createObjectStore("entityProfileSelect");
    }
  };

  request.onsuccess = function (event) {
    const db = event.target.result;
    const tx = db.transaction(["profiles", "userData", "entityProfileSelect"], "readonly");

    const result = {
      profile: undefined,
      user: undefined,
      entityProfile2: undefined,
    };

    let loadedCount = 0;
    const checkDone = () => {
      loadedCount++;
      if (loadedCount === 3) {
        callback(result);
      }
    };

    const profileRequest = tx.objectStore("profiles").get("entityProfile");
    profileRequest.onsuccess = function () {
      result.profile = profileRequest.result;
      checkDone();
    };

    const userRequest = tx.objectStore("userData").get("userData");
    userRequest.onsuccess = function () {
      result.user = userRequest.result;
      checkDone();
    };

    const entityProfileRequest = tx.objectStore("entityProfileSelect").get("entityProfileSelect");
    entityProfileRequest.onsuccess = function () {
      result.entityProfile2 = entityProfileRequest.result;
      checkDone();
    };

    profileRequest.onerror = userRequest.onerror = entityProfileRequest.onerror = function () {
      console.error("Erro ao buscar dados");
      callback(null);
    };
  };

  request.onerror = function () {
    console.error("Erro ao abrir IndexedDB");
    callback(null);
  };
}

export function removeFromIndexedDB(storeName, key, callback) {
  const request = indexedDB.open("MyAppDB", 5);

  request.onupgradeneeded = function (event) {
    const db = event.target.result;
    if (!db.objectStoreNames.contains(storeName)) {
      db.createObjectStore(storeName);
    }
  };

  request.onsuccess = function (event) {
    const db = event.target.result;
    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);

    const deleteRequest = store.delete(key);

    deleteRequest.onsuccess = function () {
      // sucesso ao remover
      db.close();
      if (callback) callback(true);
    };

    deleteRequest.onerror = function () {
      // erro ao remover
      db.close();
      if (callback) callback(false);
    };
  };

  request.onerror = function () {
    if (callback) callback(false);
  };
}